import { createIcon } from '@chakra-ui/react';

export const UploadIcon = createIcon({
  displayName: 'UploadIcon',
  viewBox: '0 0 20 20',
  defaultProps: {
    fill: 'none',
    height: '20',
    width: '20',
  },
  path: (
    <>
      <path
        d="M9.16699 12.5H10.8337V7.50004H13.3337L10.0003 3.33337L6.66699 7.50004H9.16699V12.5Z"
        fill="#146BBD"
      />
      <path
        d="M16.667 15H3.33366V9.16663H1.66699V15C1.66699 15.9191 2.41449 16.6666 3.33366 16.6666H16.667C17.5862 16.6666 18.3337 15.9191 18.3337 15V9.16663H16.667V15Z"
        fill="#146BBD"
      />
    </>
  ),
});
